/**
 * Main Application Component
 * 
 * Handles routing and overall application structure.
 * Provides navigation between different AI experiments and projects.
 * Uses React.Suspense for lazy loading of project components.
 */

import { lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { PROJECTS } from './config/projects';
import AsyncComponentWrapper from './components/AsyncComponentWrapper';

// Lazy load the ProjectIndex component as well
const ProjectIndex = lazy(() => import('./components/ProjectIndex'));

import './styles/global.css';

const App: React.FC = () => {
  return (
    <div className="app">
      <AsyncComponentWrapper loadingMessage="Loading application...">
        <Routes>
          <Route path="/" element={<ProjectIndex />} />
          {PROJECTS.map(project => (
            <Route
              key={project.id}
              path={project.path}
              element={
                <AsyncComponentWrapper 
                  loadingMessage={`Loading ${project.name}...`}
                  componentId={project.id}
                >
                  <project.component />
                </AsyncComponentWrapper>
              }
            />
          ))}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AsyncComponentWrapper>
    </div>
  );
};

export default App;